import { TranslationContext } from 'contexts/translation-context';
import { useContext } from 'react';
import styled from 'styled-components';
import Lottie from 'lottie-react';
import spinningDiamond from 'assets/lottie-animations/spinning-diamond.json';
import diamondsBackground from 'assets/images/join/diamondsBackground.png';
import { ClickableText } from 'components/common/buttons';
import { BlueLink } from 'components/common/link';

const Container = styled.div`
  background: #f0f0f0 0% 0% no-repeat padding-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: 0;
  margin-top: 132px;
`;
const Title = styled.div`
  font-size: 30px;
  text-align: center;
  margin-bottom: 50px;
  font-family: ${props => props.theme.fonts.montserratLight};
  color: ${props => props.theme.colors.siteBlack};
`;
const ContentMessage = styled.div`
  font-size: 17px;
  text-align: center;
  font-family: ${props => props.theme.fonts.montserratLight};
  white-space: break-spaces;
`;

const StyledLink = styled(BlueLink)`
  font-family: ${props => props.theme.fonts.montserratBold};
  font-size: 17px;
  text-decoration: auto;
`;

const ForQuestions = styled.div`
  font-size: 17px;
  text-align: center;
  font-family: ${props => props.theme.fonts.montserratLight};
`;
const AnimationWrapper = styled.div`
  height: 155px;
  width: 155px;
`;
const ImgContainer = styled.div`
  padding: 10px;
  align-self: flex-end;
`;

const StyledImage = styled.img`
  mix-blend-mode: darken;
  max-width: 100%;
  height: 380px;
`;

const ThankYouScreenForPriceList = () => {
  const TRANSLATION_TEXT = useContext(TranslationContext) as { [key: string]: string };

  const handleContactUsClick = () => {
    window.open('https://www.rapnet.com/contact/support/', '_blank');
  };

  return (
    <Container>
      <AnimationWrapper>
        <Lottie animationData={spinningDiamond} loop autoplay />
      </AnimationWrapper>
      <Title>{TRANSLATION_TEXT.thank_you}</Title>
      <ContentMessage>{TRANSLATION_TEXT.renewal_request_has_been_sent}</ContentMessage>
      <ContentMessage>{TRANSLATION_TEXT.processed_once_payment_has_been_received}</ContentMessage>
      <br />
      <ForQuestions>
        {TRANSLATION_TEXT.if_you_have_any_questions_please_feel_free}
        <StyledLink onClick={handleContactUsClick}>{TRANSLATION_TEXT.contact_us_lower}</StyledLink>
      </ForQuestions>
      <ImgContainer>
        <StyledImage src={diamondsBackground} />
      </ImgContainer>
    </Container>
  );
};
export default ThankYouScreenForPriceList;
